import { useState, useRef, useEffect } from "react";

const PriceRangeDropdown = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (range) => {
    onChange(range);
    setOpen(false);
  };

  const priceRanges = ["₹0-₹1500", "₹1500-₹2500", "₹2500-₹5000", "₹5000+"];

  return (
    <div className="relative inline-block w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full inline-flex justify-between px-4 py-2 text-xl font-medium"
      >
        {value || '₹0-₹1500'}
        {/* <span className="ml-2 transform">{open ? "▲" : "▼"}</span> */}
      </button>

      {open && (
        <div
          className="absolute mt-2 w-full bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-10"
          style={{ boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)" }}
        >
          <ul className="py-1 max-h-56 overflow-auto">
            {priceRanges.map((range) => (
              <li
                key={range}
                onClick={() => handleSelect(range)}
                className={`cursor-pointer px-4 py-2 text-sm ${
                  value === range
                    ? "bg-blue-100 text-blue-700"
                    : "text-gray-700"
                } hover:bg-blue-100 hover:text-blue-700`}
              >
                {range}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PriceRangeDropdown;
